
module.exports = {

  supportedChains: ['eth', 'trx']

}
